// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import { Home } from "./pages/home/Home";
// import { About } from "./pages/about/About";
// import { Parteners } from "./pages/parteners/Parteners";
// import { Contact } from "./pages/contact/Contact";
// import { Solutions } from "./pages/solutions/Solutions";
// import { AskCharlee } from "./pages/products/askcharlee/AskCharlee";
// import { SeeCharlee } from "./pages/products/seecharlee/SeeCharlee";
// import { DocuCharlee } from "./pages/products/docucharlee/DocuCharlee";
// import { FindCharlee } from "./pages/products/findcharlee/FindCharlee";
// import { Blogs } from "./pages/blogs/Blogs";
// import { BlogContent } from "./pages/blogs/BlogContent";
// import { EventContent } from "./pages/blogs/EventContent";
// import { Usecase } from "./pages/usecase/Usecase";
// import ResearchPage from "./pages/research/research";
// import { VideoPages } from "./pages/videos/videos";
// import { LargeLossAlerts } from "./pages/usecase/usecases/LargeLossAlerts";
// import { EarlySeveritySignalDetection } from "./pages/usecase/usecases/EarlySeveritySignalDetection";
// import { ReserveAdequacyMonitoring } from "./pages/usecase/usecases/ReserveAdequacyMonitoring";
// import { HighSeverityPotentialClaims } from "./pages/usecase/usecases/HighSeverityPotentialClaims";
// import { ProactiveSeverityLitigatioinIntelligence } from "./pages/usecase/usecases/ProactiveSeverityLitigatioinIntelligence";
// import { IntelligentClaimsDocumentSummarization } from "./pages/usecase/usecases/IntelligentClaimsDocumentSummarization";
// import { RiteCharlee } from "./pages/products/ritecharlee/ritecharlee";

// export const Router = () => {
//   return (
//     <BrowserRouter>
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/about" element={<About />} />
//         <Route path="/partners" element={<Parteners />} />
//         <Route path="/connect" element={<Contact />} />
//         <Route path="/solutions1" element={<Solutions />} />
//         <Route path="/blogs/*" element={<Blogs />} />
//         <Route path="/event/:eventname" element={<EventContent />} />
//         <Route path="/blog/*" element={<BlogContent />} />
//         <Route path="/product/askcharlee" element={<AskCharlee />} />
//         <Route path="/product/seecharlee" element={<SeeCharlee />} />
//         <Route path="/product/docucharlee" element={<DocuCharlee />} />
//         <Route path="/product/findcharlee" element={<FindCharlee />} />
//         <Route path="/product/ritecharlee" element={<RiteCharlee />} />
//         <Route path="/usecase/*" element={<Usecase />} />
//         <Route path="/solutions" element={<ResearchPage />} />
//         <Route path="/videos-page" element={<VideoPages />} />
//         <Route
//           path="/usecase/large-loss-alerts"
//           element={<LargeLossAlerts />}
//         />
//         <Route
//           path="/usecase/early-severity-signal-detection"
//           element={<EarlySeveritySignalDetection />}
//         />
//         <Route
//           path="/usecase/reserve-adequacy-monitoring"
//           element={<ReserveAdequacyMonitoring />}
//         />
//         <Route
//           path="/usecase/high-severity-potential-claims"
//           element={<HighSeverityPotentialClaims />}
//         />
//         <Route
//           path="/usecase/proactive-severity-litigation-intelligence"
//           element={<ProactiveSeverityLitigatioinIntelligence />}
//         />
//         <Route
//           path="/usecase/intelligent-claims-document-summarization"
//           element={<IntelligentClaimsDocumentSummarization />}
//         />
//       </Routes>
//     </BrowserRouter>
//   );
// };

// src/router.js
import React from "react";
import { useRoutes, Navigate } from "react-router-dom";
import { SEO } from "./components/SEO";

// Pages
import { Home } from "./pages/home/Home";
import { About } from "./pages/about/About";
import { Parteners } from "./pages/parteners/Parteners";
import { Contact } from "./pages/contact/Contact";
import { Solutions } from "./pages/solutions/Solutions";
import { AskCharlee } from "./pages/products/askcharlee/AskCharlee";
import { SeeCharlee } from "./pages/products/seecharlee/SeeCharlee";
import { DocuCharlee } from "./pages/products/docucharlee/DocuCharlee";
import { FindCharlee } from "./pages/products/findcharlee/FindCharlee";
import { RiteCharlee } from "./pages/products/ritecharlee/ritecharlee";

import { Blogs } from "./pages/blogs/Blogs";
import { BlogContent } from "./pages/blogs/BlogContent";
import { EventContent } from "./pages/blogs/EventContent";

import { Usecase } from "./pages/usecase/Usecase";
import ResearchPage from "./pages/research/research";
import { VideoPages } from "./pages/videos/videos";

import { LargeLossAlerts } from "./pages/usecase/usecases/LargeLossAlerts";
import { EarlySeveritySignalDetection } from "./pages/usecase/usecases/EarlySeveritySignalDetection";
import { ReserveAdequacyMonitoring } from "./pages/usecase/usecases/ReserveAdequacyMonitoring";
import { HighSeverityPotentialClaims } from "./pages/usecase/usecases/HighSeverityPotentialClaims";
import { ProactiveSeverityLitigatioinIntelligence } from "./pages/usecase/usecases/ProactiveSeverityLitigatioinIntelligence";
import { IntelligentClaimsDocumentSummarization } from "./pages/usecase/usecases/IntelligentClaimsDocumentSummarization";

// Optional: if you have a 404 page
// import { NotFound } from "./pages/not-found/NotFound";

function RouteWithSEO({
  title,
  description,
  url,
  image,
  type,
  jsonLd,
  children,
}) {
  return (
    <>
      <SEO
        title={title}
        description={description}
        url={url}
        image={image}
        type={type}
        jsonLd={jsonLd}
      />
      {children}
    </>
  );
}

// Centralized route config with SEO
const routesConfig = [
  {
    path: "/",
    element: <Home />,
    title:
      "Charlee.ai — AI-Powered Claims & Risk Intelligence for P&C Insurance",
    description:
      "AI-driven claims and risk intelligence for P&C insurers. Predict litigation, severity, fraud, and optimize claims and underwriting decisions.",
    url: "https://charlee.ai/",
    // TODO: replace with your real OG image URL
    image: "https://charlee.ai/assets/images/og/charlee-home-og.png",
    type: "website",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Charlee.ai",
      url: "https://charlee.ai",
      logo: "https://charlee.ai/assets/images/logo.png",
      description:
        "AI-powered claims and risk intelligence platform built for P&C insurance carriers.",
      sameAs: ["https://www.linkedin.com/company/charleeai"],
    },
  },
  {
    path: "/about",
    element: <About />,
    title:
      "About Charlee.ai | AI-Powered Claims Intelligence for Insurance Carriers",
    description:
      "Learn how Charlee.ai uses AI and millions of real-world claims to improve claims accuracy, reduce litigation, and enhance underwriting performance.",
  },
  {
    path: "/partners",
    element: <Parteners />,
    title: "Charlee.ai Partners | Integrations & Ecosystem for Insurance AI",
    description:
      "Explore Charlee.ai technology partners and integrations for P&C claims systems, core platforms, and insurance data ecosystems.",
  },
  {
    path: "/connect",
    element: <Contact />,
    title:
      "Contact Charlee.ai | Schedule a Demo of AI Claims & Underwriting Tools",
    description:
      "Request a Charlee.ai demo. See how AI improves claims accuracy, litigation prediction, and underwriting results.",
  },
  {
    path: "/solutions1",
    element: <Solutions />,
    title:
      "AI Solutions for P&C Insurance | Litigation, Severity & Fraud Prediction",
    description:
      "AI solutions for P&C insurance: litigation prediction, severity scoring, document intelligence, and risk insights across the claim lifecycle.",
  },
  {
    path: "/solutions",
    element: <ResearchPage />,
    title:
      "Charlee.ai Solutions & Research | Claims and Underwriting Intelligence",
    description:
      "Deep-dive into Charlee.ai solutions and applied research for improving claims outcomes, underwriting precision, and portfolio performance.",
  },

  // Products
  {
    path: "/product/askcharlee",
    element: <AskCharlee />,
    title:
      "AskCharlee | Conversational AI for Claims, Policy & Document Queries",
    description:
      "Conversational AI for claims and underwriting. Search notes, policies, and documents instantly using natural language queries.",
    url: "https://charlee.ai/product/askcharlee",
    type: "product",
  },
  {
    path: "/product/seecharlee",
    element: <SeeCharlee />,
    title: "SeeCharlee | Claims & Underwriting Analytics Dashboard",
    description:
      "Visual dashboards for insurance claims and underwriting. Track litigation, severity, and exposure trends with advanced analytics.",
    url: "https://charlee.ai/product/seecharlee",
    type: "product",
  },
  {
    path: "/product/docucharlee",
    element: <DocuCharlee />,
    title:
      "DocuCharlee | Insurance Document Intelligence & Automated Summaries",
    description:
      "AI-powered document intelligence for insurance. Extract, classify, and summarize claim documents to reduce manual processing time by up to 60%.",
    url: "https://charlee.ai/product/docucharlee",
    image: "https://charlee.ai/assets/images/og/docucharlee-og.png", // TODO: update
    type: "product",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: "DocuCharlee",
      applicationCategory: "BusinessApplication",
      operatingSystem: "Any",
      description:
        "AI-powered document intelligence for insurance claims, automating extraction, classification, and summarization.",
      offers: {
        "@type": "Offer",
        availability: "https://schema.org/InStock",
      },
    },
  },
  {
    path: "/product/findcharlee",
    element: <FindCharlee />,
    title: "FindCharlee | Litigation & Severity Prediction for Claims Teams",
    description:
      "Predict litigation, severity, and fraud early in the claim lifecycle using AI trained on millions of P&C claims.",
    url: "https://charlee.ai/product/findcharlee",
    type: "product",
  },
  {
    path: "/product/ritecharlee",
    element: <RiteCharlee />,
    title: "RiteCharlee | Underwriting Risk Intelligence & Exposure Insights",
    description:
      "AI-powered underwriting insights that surface hidden exposure patterns and improve risk selection and pricing accuracy.",
    url: "https://charlee.ai/product/ritecharlee",
    type: "product",
  },

  // Blog & content
  {
    path: "/blogs/*",
    element: <Blogs />,
    title:
      "Insurance AI Insights | Claims & Underwriting Analytics Blog | Charlee.ai",
    description:
      "Insights on AI for insurance, claims analytics, underwriting transformation, and risk intelligence from Charlee.ai.",
  },
  {
    path: "/blog/*",
    element: <BlogContent />,
    title:
      "Charlee.ai Blog | Articles on Claims AI, Underwriting & Risk Intelligence",
    description:
      "Read detailed articles about AI in claims, underwriting analytics, litigation prediction, and operational excellence.",
    type: "article",
  },
  {
    path: "/event/:eventname",
    element: <EventContent />,
    title: "Charlee.ai Events | Conferences & InsurTech Engagements",
    description:
      "Learn more about Charlee.ai sessions, talks, and presence at industry conferences and InsurTech events.",
    type: "event",
  },

  // Use cases
  {
    path: "/usecase/*",
    element: <Usecase />,
    title: "Insurance AI Use Cases | Charlee.ai",
    description:
      "Explore AI use cases across claims and underwriting: early severity detection, litigation prediction, document summarization, and more.",
  },
  {
    path: "/usecase/large-loss-alerts",
    element: <LargeLossAlerts />,
    title: "Large Loss Alerts | Claims Severity Intelligence | Charlee.ai",
    description:
      "Identify potential large-loss claims earlier with AI-driven severity alerts and proactive claims management.",
  },
  {
    path: "/usecase/early-severity-signal-detection",
    element: <EarlySeveritySignalDetection />,
    title: "Early Severity Signal Detection | Claim Risk Signals | Charlee.ai",
    description:
      "Detect early severity signals from notes and documents so adjusters can intervene before losses escalate.",
  },
  {
    path: "/usecase/reserve-adequacy-monitoring",
    element: <ReserveAdequacyMonitoring />,
    title:
      "Reserve Adequacy Monitoring | Claims Reserve Intelligence | Charlee.ai",
    description:
      "Monitor reserve adequacy using predictive analytics to reduce under-reserving and financial volatility.",
  },
  {
    path: "/usecase/high-severity-potential-claims",
    element: <HighSeverityPotentialClaims />,
    title:
      "High Severity Potential Claims | Predictive Claim Triage | Charlee.ai",
    description:
      "Identify high-severity potential claims early and prioritize resources for better outcomes and lower leakage.",
  },
  {
    path: "/usecase/proactive-severity-litigation-intelligence",
    element: <ProactiveSeverityLitigatioinIntelligence />,
    title: "Proactive Severity & Litigation Intelligence | Charlee.ai",
    description:
      "Combine severity and litigation intelligence to drive proactive outreach and optimal resolution strategies.",
  },
  {
    path: "/usecase/intelligent-claims-document-summarization",
    element: <IntelligentClaimsDocumentSummarization />,
    title: "Intelligent Claims Document Summarization | DocuCharlee Use Case",
    description:
      "Automatically summarize complex claim files using AI, helping adjusters review documents faster and focus on decisions.",
  },

  // Videos
  {
    path: "/videos-page",
    element: <VideoPages />,
    title: "Charlee.ai Videos | Product Demos & Use Case Walkthroughs",
    description:
      "Watch Charlee.ai demos and walkthroughs that showcase claims AI, document intelligence, and underwriting insights.",
  },
];

// Turn the config into real React Router routes
export const Router = () => {
  const element = useRoutes([
    ...routesConfig.map((route) => ({
      path: route.path,
      element: (
        <RouteWithSEO
          title={route.title}
          description={route.description}
          url={route.url}
          image={route.image}
          type={route.type}
          jsonLd={route.jsonLd}
        >
          {route.element}
        </RouteWithSEO>
      ),
    })),

    // Example legacy alias: /contact-us -> /connect
    {
      path: "/contact-us",
      element: <Navigate to="/connect" replace />,
    },

    // Optional 404
    // { path: "*", element: <NotFound /> },
  ]);

  return element;
};
